import { Link } from "react-router-dom";
import HeroBanner from "../DynamicHero";
import { FaArrowRight } from "react-icons/fa";
import { ProductCategory } from "../../types/Generic";
import { useTranslation } from "react-i18next";

interface CategoryPageProps {
  productCategory: ProductCategory;
}

const EshopProductCategoryPage = (props: CategoryPageProps) => {
  const { productCategory } = props;
  const { t } = useTranslation("products");

  return (
    <>
      <HeroBanner text={t(productCategory.title)} />
      <section className="relative w-full h-full ">
        <div className="w-full bg-gradient-to-r from-[#F2F6F7] to-white px-[5%]">
          <div className="pt-16 pb-12 md:pt-20 maxContainer ">
            <h2 className="mt-2 mb-5 font-bold leading-tight text-[28px] ss:text-md md:text-lg md:max-w-[599px] tracking-wide">
              {t(productCategory.title)}
            </h2>

            <p className="md:text-[18px] text-greyText">
              {t(productCategory.description!)}
            </p>
          </div>
        </div>
        <div className="px-[5%] ">
          <div className="pt-16 pb-8 md:pb-20 maxContainer ">
            <div className="relative w-full ">
              <div className="flex justify-center ss:justify-normal flex-wrap ss:flex-nowrap ss:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-y-12 gap-x-[3%]">
                {productCategory.products?.length &&
                  productCategory.products?.map((item, index) => (
                    <Link
                      key={index}
                      to={`${productCategory.path}/p=${item.title.toLowerCase().replace(/\s+/g, "-")}`}
                      className="group flex relative flex-col max-w-[298px] w-full gap-2 transition-all duration-700 rounded-lg"
                    >
                      <div className="flex flex-col relative items-center justify-center w-full h-72 p-4 bg-[#F2F6F7] rounded-lg overflow-hidden">
                        <img
                          src={item.images[0]}
                          alt={item.title}
                          className="object-contain max-w-full max-h-full transition-transform duration-300 ease-in-out group-hover:scale-105"
                        />

                        <div className="absolute inset-0 transition-all duration-700 ease-in-out translate-y-full opacity-0 bg-black/80 group-hover:opacity-30 group-hover:translate-y-0" />

                        <div className="inline-flex items-center justify-center gap-4 bg-[#2e80c3c0] group-hover:bg-[#2974b1] rounded-sm px-4 absolute bottom-0 left-0 w-full text-white transition-all font-bold py-2 duration-700 ease-in-out">
                          <h2 className="font-bold text-center">
                            {t(item.title)}
                          </h2>
                          <FaArrowRight className="hidden text-white transition-transform duration-700 ease-in-out group-hover:flex group-hover:-rotate-45" />
                        </div>
                      </div>
                    </Link>
                  ))}
                {productCategory.subCategories?.map((item, index) => (
                  <Link
                    key={index}
                    to={`${item.path.toLowerCase().replace(/\s+/g, "-")}`}
                    className="group flex relative flex-col max-w-[298px] w-full gap-2 transition-all duration-700 rounded-lg "
                  >
                    <div className="flex flex-col relative items-center justify-center w-full h-72 p-4 bg-[#F2F6F7] rounded-lg overflow-hidden">
                      <div className="absolute px-2 py-1 text-white bg-[#2e80c341] z-10 text-[12px] text-medium rounded-md top-4 left-4">
                        <p>category</p>
                      </div>

                      <img
                        src={item.bg}
                        alt={item.title}
                        className="object-contain max-w-full max-h-full transition-transform duration-300 ease-in-out group-hover:scale-105"
                      />

                      <div className="absolute inset-0 transition-all duration-700 ease-in-out translate-y-full opacity-0 bg-black/80 group-hover:opacity-30 group-hover:translate-y-0" />

                      <div className="inline-flex items-center justify-center gap-4 bg-[#2e80c3c0] group-hover:bg-[#2974b1] rounded-sm px-4 absolute bottom-0 left-0 w-full text-white transition-all font-bold py-2 duration-700 ease-in-out">
                        <h2 className="font-bold text-center">
                          {t(item.title)}
                        </h2>
                        <FaArrowRight className="hidden text-white transition-transform duration-700 ease-in-out group-hover:flex group-hover:-rotate-45" />
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EshopProductCategoryPage;
